import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Waves, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#16171c] px-4 text-white">
      <div className="w-full max-w-sm">
        <Link to="/" className="mb-6 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white">
          <ArrowLeft size={16} /> Back to showroom
        </Link>
        <div className="rounded-2xl border border-white/10 bg-[#1d1f26] p-8">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-500/15 text-cyan-300">
            <Waves size={20} />
          </span>
          <h1 className="mt-4 font-display text-2xl font-semibold tracking-tight">Admin sign in</h1>
          <p className="mt-1 text-sm text-slate-400">Manage your spa catalogue and view enquiries.</p>
          <form onSubmit={submit} className="mt-6 space-y-3">
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border-white/10 bg-white/5 focus-visible:ring-cyan-500"
              data-testid={ADMIN.loginEmail}
            />
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border-white/10 bg-white/5 focus-visible:ring-cyan-500"
              data-testid={ADMIN.loginPassword}
            />
            <Button
              type="submit"
              disabled={loading}
              className="w-full rounded-full bg-cyan-500 py-6 font-semibold text-black hover:bg-cyan-400"
              data-testid={ADMIN.loginSubmit}
            >
              {loading ? <Loader2 className="animate-spin" size={18} /> : "Sign in"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
